import { Injectable } from '@angular/core';
import { Api } from '../api/api';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/operator/mergeMap';

/*
  Generated class for the ProfileSettingsProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ProfileSettingsProvider {
  constructor(private api: Api) {}

  getCurrentUser(): Observable<any> {
    return this.api.post('user/loadCurrentUser', {}).map(res => {
      return res;
    });
  }

  getUser(userId: string): Observable<any> {
    return this.api.post('user/findUser', { user: userId }).map(res => {
      return res;
    });
  }

  updateUser(user: any): Observable<any> {
    return this.api.post('user/updateUser', user).map(res => {
      return res;
    });
  }
  deleteAcount(archive): Observable<any> {
    return Observable.fromPromise(
      this.api.delete('user/delete?archive=' + archive, {})
    ).mergeMap(res => {
      return res;
    });
  }

  getInterests(): Observable<any> {
    return this.api.post('user/getInterests', {}).map(res => {
      return res;
    });
  }

  addInterest(tag: string): Observable<any> {
    return this.api.post('user/addInterest', { tag: tag }).map(res => {
      return res;
    });
  }

  removeInterest(id: number): Observable<any> {
    return this.api.post('user/removeInterest', { id: id }).map(res => {
      return res;
    });
  }

  changePassword(
    currentPassword: string,
    newPassword: string
  ): Observable<any> {
    return this.api
      .post('user/changePassword', {
        currentPassword: currentPassword,
        newPassword: newPassword,
      })
      .map(res => {
        return res;
      });
  }

  /*getCountries(): Observable<any> {
    return this.api.getMock('countries.json')
  }*/
}



// WEBPACK FOOTER //
// ./src/providers/profile-settings/profile-settings.ts